import { Route, Routes } from 'react-router-dom';
import { OverviewPage } from './OverviewPage';
import { EditPage } from './EditPage';

export function ReportBuilderRoutes(): JSX.Element {
    return (
        <Routes>
            <Route path="edit/:id" element={<EditPage />} />
            <Route index element={<OverviewPage />} />
        </Routes>
    );
}
